import React, { Suspense, useEffect } from 'react';
import { useMediaQuery, useTheme } from '@mui/material';
import { useCalendar } from '../calendarContext';
import { useCalendarViews } from './calendarViewsProvider';

// Lazy load the components 
const WeekViewDesktop = React.lazy(() => import('../week/weekView_desktop'));

const WeekView = () => {
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm")); // Check if screen size is small
    const { selectedDate, bookingDatas } = useCalendar();
    const { setView } = useCalendarViews();
    useEffect(() => {
        if (isSmallScreen) {
            setView("day"); // Switch to day view on mobile.
        }
    }, [isSmallScreen, setView]);

    return (
        <Suspense fallback={<div>Loading...</div>}>
            {!isSmallScreen &&
                <WeekViewDesktop selectedDate={selectedDate} bookingDatas={bookingDatas} />}
        </Suspense>
    );
};

export default WeekView;
